import * as types from './mutation-types'

export default {
  [types.LOAD_QVCT_CARTEGORIE](state, data) {
    state.qvctCategories = data
  },

  [types.LOAD_QVCT_CARTEGORIE_TYPE](state, data) {
    state.qvctCategoriesType = data
  },

  [types.ADD_QVCT_CARTEGORIE](state, data) {
    state.qvctCategories.push(data)
  },

}
